
import Vue, { PropType } from 'vue';
import RunnitImage from './RunnitImage.vue';

export default Vue.extend({
	name: 'RunnitActiveGenerationIndicator',
	components: { RunnitImage },
	props: {
		direction: {
			type: String as PropType<'up' | 'down'>,
			required: true,
			validator: (v: string) => v === 'up' || v === 'down',
		},
		nodeAvatar: {
			type: Object,
			default: null,
		},
	},
});
